import { PageShell, type PageShellProps } from '@repo/ui/components/layout/page-shell'
import type { ReactNode } from 'react'
import { ExpandablePageShell, type ExpandablePageShellProps } from './expandable-page-shell'

export function WorkspaceRouteShell(props: ExpandablePageShellProps) {
  return <ExpandablePageShell {...props} />
}

export function DocumentRouteShell({
  children,
  width = 'content',
  density = 'default',
  contentSize = 'md',
  ...props
}: PageShellProps & { children: ReactNode }) {
  return (
    <PageShell width={width} density={density} contentSize={contentSize} {...props}>
      {children}
    </PageShell>
  )
}

export function ReportRouteShell({
  children,
  width = 'full',
  density = 'default',
  contentSize = 'md',
  ...props
}: PageShellProps & { children: ReactNode }) {
  return (
    <PageShell width={width} density={density} contentSize={contentSize} {...props}>
      {children}
    </PageShell>
  )
}
